import http from '@/plugins/axios/axios';

export default class FeriadoService {

    salvar(requisicao) {       
        return http.post('/api/cargo/salvar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/cargo/excluir', requisicao);
    }

    buscar(requisicao) {       
        return http.post('/api/cargo/buscar', requisicao);
    }
    
    listar(requisicao) {       
        return http.post('/api/cargo/listar', requisicao);
    }    
}